module.exports = __webpack_public_path__ + "static/dolapo-1c191c63883e6fac0e5a7a60820b17d5.jpg";